import React, { Suspense, lazy } from 'react';
import Fallback from '../Fallback';

const width = 600;
const height = 200;

export default function LazyDashboardPieChart({__placeholder_html__, ...props}) {
  const DashboardPieChart = lazy(() =>
    import('../../components/dashboard/DashboardPieChart')
  );
  return (
    <Suspense
      fallback={<Fallback __placeholder_html__={__placeholder_html__} />}
    >
      <DashboardPieChart width={width} height={height} {...props} />
    </Suspense>
  );
}
